(function(core) {
    if (window) {
        window.OE = core(window, window.document);

        // initialize after content loaded
        document.addEventListener("DOMContentLoaded", window.OE.init.bind(window.OE) );
    }
})(function(global, doc) {
    "use strict";

    var OE = {};

    OE.version = '1.0';

    OE.$doc  = doc;
    OE.$win  = global;
    OE.$html = doc.querySelector('html');

    OE.TOUCH = OE.$html.classList.contains('touchevents');
    OE.CLICK = 'click'; // 'ontouchstart' in document.documentElement ? 'touchstart' : 'click';
    OE.TOUCHCLICK = 'ontouchstart' in document.documentElement ? 'touchstart' : 'click';
    OE.MOUSEOVER = 'mouseenter touchstart MSPointerDown pointerdown';
    OE.MOUSEOUT = 'mouseleave touchend MSPointerUp pointerup';
    OE.MOUSEDOWN = 'ontouchstart' in document.documentElement ? 'touchstart' : 'mousedown';//  'mousedown touchstart MSPointerDown pointerdown';
    OE.MOUSEUP = 'ontouchend' in document.documentElement ? 'ontouchend' : 'mouseup';

    OE.Plugins = {};
    OE.Utils = {};

    OE.Utils.getOptionsFromString = function(options, string)
    {
        options = typeof(options) !== 'object' ? {} : options;
        string = typeof(string) !== 'string' ? '' : string;

        var json = null;

        if(string)
        {
            // try to decode json string
            try { json = JSON.parse(string); } catch(ev) { }

            if(!json)
            {
                // not successful, try to create a JSON string
                string = string.replace(/(^|,|\t+)([a-z0-9\_\-]+)(\:)/ig,"$1\"$2\"$3");
                string = string.replace(/(\:)'(.*)'(,|$)/g, "$1\"$2\"$3");
                string = '{' + string + '}';

                // and retry decoding to JSON object:
                try { json = JSON.parse(string); } catch(ev) { }
            }

            if(json)
            {
                for(var p in json)
                {
                    options[p] = json[p];
                }
            }
        }

        return options;
    };

    var delegatedEvents = {};
    OE.Utils.delegateEvent = function(eventname, func, querySelector)
    {
        if(typeof func === 'function' && typeof querySelector === 'string' && typeof eventname === 'string')
        {
            if(typeof delegatedEvents[eventname] === 'undefined')
            {
                delegatedEvents[eventname] = [];
                OE.$doc.addEventListener(eventname, docEventListener.bind(null, eventname));
            }

            delegatedEvents[eventname].push({
                querySelector : querySelector,
                func : func
            });
        }
    };

    var docEventListener = function(eventname, e)
    {
        if (e.target)
        {
            var events = delegatedEvents[eventname],
                event_count = events.length;

            for(var i = 0; i < event_count; i++)
            {
                if(OE.Utils.matches(e.target, events[i].querySelector))
                {
                    return events[i].func.bind(e.target)(e);
                }
                else
                {
                    var p = e.target.parentElement;
                    while( p ) {
                        if(OE.Utils.matches(p, events[i].querySelector))
                        {
                            return events[i].func.bind(p)(e);
                        }
                        p = p.parentElement;
                    }
                }
            }
        }
    };

    var newEvent = function(eventname, options)
    {
        var event;

        if(typeof(options) !== 'object')
        {
            options = {};
        }

        try {
            event = new Event(eventname, options);
        }
        catch (error) {
            event = document.createEvent("Event");
            var bubbles = typeof(options.bubbles) === 'undefined' || options.bubbles;
            var cancelable = typeof(options.bubbles) === 'undefined' || options.bubbles;

            event.initEvent(eventname, !bubbles, !cancelable);
        }

        return event;
    };

    OE.Utils.triggerEvent = function(element, eventname)
    {
        var options = {
            'view': this,
            'bubbles': typeof(arguments[2]) !== 'undefined' ? Boolean(arguments[2]) : true,
            'cancelable': typeof(arguments[3]) !== 'undefined' ? Boolean(arguments[3]) : true,
        };

        if(element)
        {
            element.dispatchEvent(newEvent(eventname, options));
        }
    };

    OE.Utils.createCustomEvent = function(eventname, bubbles, cancelable)
    {
        var event;
        if (typeof CustomEvent === 'function') {
            event = new CustomEvent(eventname, {bubbles: bubbles !== false, cancelable: cancelable !== false});
        }
        else
        {
            event = document.createEvent('Event');
            event.initEvent(eventname, bubbles === false, cancelable === false);
        }

        return event;
    };

    OE.Utils.getElementDimensions = function(element, type)
    {
        var dimensions = {
                width: 0,
                height: 0,
                top: 0,
                left: 0,
                right: 0,
                bottom: 0
            },
            devicePixelRatio = window.devicePixelRatio || 1,
            rect = element.getBoundingClientRect();

        dimensions.width = parseInt(element.offsetWidth) * devicePixelRatio;
        dimensions.height = parseInt(element.offsetHeight) * devicePixelRatio;

        dimensions.top = parseInt(rect.top) + OE.Utils.getScrollPosition().top;
        dimensions.left = parseInt(rect.left) + OE.Utils.getScrollPosition().left;
        dimensions.bottom = dimensions.top + dimensions.height;
        dimensions.right = dimensions.left + dimensions.width;

        if(typeof(type) !== 'undefined')
        {
            return dimensions[type];
        }

        return dimensions;
    };

    OE.Utils.getScrollPosition = function(element)
    {
        if(typeof(element) !== 'undefined' && element !== document && element !== window)
        {
            return {
                top : parseInt(element.scrollTop || 0),
                left : parseInt(element.scrollLeft || 0),
                maxtop : Math.max( element.scrollHeight, element.offsetHeight, element.clientHeight, element.scrollHeight, element.offsetHeight ) - parseInt(element.innerHeight),
                maxleft : Math.max( element.scrollWidth, element.offsetWidth, element.clientWidth, element.scrollWidth, element.offsetWidth ) - parseInt(element.innerWidth)
            };
        }
        else
        {
            return {
                top : parseInt(window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0),
                left : parseInt(window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0),
                maxtop : Math.max( document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight ) - parseInt(window.innerHeight),
                maxleft : Math.max( document.body.scrollWidth, document.body.offsetWidth, document.documentElement.clientWidth, document.documentElement.scrollWidth, document.documentElement.offsetWidth ) - parseInt(window.innerWidth)
            };
        }
    };

    OE.Utils.getVisibleDocumentArea = function()
    {
        return {
            top : parseInt(window.pageYOffset),
            left : parseInt(window.pageXOffset),
            bottom : parseInt(window.pageYOffset) + parseInt(window.innerHeight),
            right : parseInt(window.pageXOffset) + parseInt(window.innerWidth)
        };
    };

    var _scripts = [];
    OE.Utils.loadScript = function(url, callback)
    {
        if(typeof(callback) !== 'function')
        {
            callback = function() {};
        }

        if(_scripts.indexOf(url) > -1)
        {
            callback();
            return;
        }

        var script = document.createElement("script");
        script.type = "text/javascript";

        if (script.readyState)
        {  //IE
            script.onreadystatechange = function(){
                if (script.readyState === "loaded" || script.readyState === "complete")
                {
                    script.onreadystatechange = null;
                    callback();
                }
            };
        }
        else
        {  //Others
            script.onload = function(){
                callback();
            };
        }

        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);
        _scripts.push(url);
    };

    OE.Utils.getMetaVar = function(name)
    {
        var tags = document.querySelectorAll('meta[name]'),
            tag_count = tags.length;

        for(var i = 0; i < tag_count; i++)
        {
            if(tags[i].getAttribute('name') === name && tags[i].hasAttribute('content'))
            {
                return tags[i].getAttribute('content');
            }
        }
        return null;
    };

    OE.Utils.trim = function(string)
    {
        return string.trim().replace(/\s/g,' ').replace(/ +/g,' ');
    };

    OE.Utils.isNode = function(element)
    {
        return typeof HTMLElement === "object" ? element instanceof HTMLElement : element && typeof element === "object" && element !== null && element.nodeType === 1 && typeof element.nodeName==="string";
    };

    OE.Utils.matches = function(element, query)
    {
        var ElemProto = Element.prototype,
            methodName = null;

        if (ElemProto.matches )
        {
            methodName = 'matches';
        }
        else if ( ElemProto.matchesSelector )
        {
            methodName = 'matchesSelector';
        }
        else
        {
            var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];
            for ( var i=0; i < prefixes.length; i++ )
            {
                var prefix = prefixes[i];
                var method = prefix + 'MatchesSelector';
                if ( ElemProto[ method ] )
                {
                    methodName = method;
                    break;
                }
            }
        }

        if(methodName !== null)
        {
            return element[methodName](query);
        }
    };

    OE.Utils.getURLParameter = function(key, searchstring)
    {
        if(typeof searchstring === 'undefined')
        {
            searchstring = OE.$win.location.search;
        }

        if(typeof key !== "string")
        {
            return;
        }

        var result = (new RegExp("[?|&]" + key + "=" + "([^&;]+?)(&|#|;|$)", "i")).exec(searchstring) || [null,""];

        return decodeURIComponent(result[1].replace(/\+/g,"%20")) || null;
    };


    var PluginNames = [];
    var getPluginNames = function(initializable)
    {
        initializable = initializable === true;

        return PluginNames.filter(function(value){
            // a plugin name is only valid if it's (a) a string, (b) a method exists in main js object and (c) if it contains an init() routine
            return typeof(value) === 'string' && typeof(OE.Plugins[value]) !== 'undefined' && (!initializable || typeof(OE.Plugins[value].init) === 'function');
        });
    };

    OE.init = function()
    {
        // get clean plugins list
        var pluginnames = getPluginNames(true),
            plugincount = pluginnames.length;

        for(var i = 0; i < plugincount; i++)
        {
            // for each plugin - execute init routine
            OE.getPlugin(pluginnames[i]).init();
        }
    };

    OE.getPlugin = function(pluginname)
    {
        return typeof(pluginname) === 'string' && typeof(OE.Plugins[pluginname]) === 'object' ? OE.Plugins[pluginname] : {};
    };

    OE.addPlugin = function(name, object, priority)
    {
        OE.Plugins[name] = object; // add plugin object to main object

        // get valid priority
        priority = parseInt(priority);
        priority = Math.max(isNaN(priority) ? 0 : priority, PluginNames.length);

        // fill up plugins array if priority is greater than plugins array length
        if(priority > PluginNames.length)
        {
            PluginNames = PluginNames.concat(Array.apply(null, Array(priority - PluginNames.length)));
        }

        // add plugin name to plugins array
        PluginNames.splice(priority, 0, name);
    };

    return OE;
});

var CLICK = 'ontouchstart' in document.documentElement ? 'touchstart' : 'click',
    MOUSEDOWN = 'ontouchstart' in document.documentElement ? 'touchstart' : 'mousedown',
    MOUSEUP = 'ontouchend' in document.documentElement ? 'touchend' : 'mouseup';
